/**
 * 印尼语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "Cina",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "Inggris",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "chinese traditional",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "Jepang",
			langimg: "../assets/zg.png"
		},

		{
			type: "Vietnamese",
			name: "Vietnam",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "Malay",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "Hindi",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "Thai",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "Russian",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "IndonesiaName",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Indonesian",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "home page",
		activity: "activity",
		to_promote: "ekstensi",
		help: "Bantuan",
		my: "saya"
	},
	// 提示
	prompt: {
		verification: "Galat kode verifikasi",
		account: "Akun nomor 8-20 digit, nomor murni atau huruf",
		password: "Kata sandi lebih besar dari atau sama dengan 6 digit + huruf atau kombinasi karakter",
		two: "Dua kata sandi tidak konsisten",
		successful: "login berhasil",
		loginsuccessful: "Login berhasil",
		null: "Kata sandi akun tidak dapat kosong",
		Binding: "Pengikatan berhasil",
		address: "Silakan isi alamat",
		Please_choose: "Silakan pilih satu item pertama dan masukkan jumlah taruhan",
		Bet_type: "Please select the bet type first",
		success: "Bertaruhan berhasil",
		complete_password: "Silakan masukkan sandi lengkap",
		copy_success: "Disalin ke papan klip",
		copy_fail: "salinan gagal",
		Set_success: "Tetapkan dengan sukses",
		Set_password: "Silakan tetapkan kata sandi 6 digit, yang tidak dapat mengandung ‘huruf, cocok dan ruang’",
		update_success: "Berubah dengan sukses",
		input_number: "Please enter quantity",
		addressvalue: "Silakan pilih alamat dompet"
	},
	head: { //头部
		luckyhash: "Personal Avatar",
		address: "Ikat alamat dompet",
		history: "Sejarah taruhan",
		help: "Bantuan",
		lotteryRecord: "Catatan loteri",
		notice: "Daftar pengumuman",
		question: "masalah umum",
		performance: "hadiah",
		add_address: "Tambah Dompet",
		asset: "Kata sandi aset",
		balance: "Perincian keseimbangan",
		exchangeRecord: "pertukaran",
		forrecord: "Catatan pertukaran",
		language: "Pengaturan bahasa",
		update_assets_password: "Modify asset password",
		update_login_password: "Ubah kata sandi daftar masuk",

		myteam: "Timku",
		recharge: "Balance recharge",
		setting: "mengatur",
		transactiondetails: "Rekaman taruhan",
		transfer: "Transfer komisi",
		user: "Pusat Pribadi",
		userInfo: "data pribadi",
		withdrawal: "Pengunduran",
		commission: "Pengunduran komisi",
		withdrawalRecord: "Rekaman penarikan",
		top_up: "Memuat ulang rekaman"
	},
	withdrawalRecord: {
		Select_month: "Select month",
		afterPrice: "balance",

	},
	withdrawal: {
		withdrawalrecord: "Rekaman penarikan",
		commission: "Aset yang dapat diuangkan",
		number: "Kuantitas untuk dipindahkan",
		withdrawal_number: "Kuantitas tarik",
		money_address: "Alamat dompet",
		addressvalue: "Silakan pilih alamat dompet",
		poundage: "Charge Servis",
		immediately: "Pengunduran segera",
		Warm_prompt: "Tip hangat: Silakan isi alamat dompet yang benar, jika tidak Anda tidak dapat menarik uang. Setelah alamat dompet penarikan dipenuhi dan terikat, tidak dapat diubah. Jika Anda perlu mengubahnya, silakan hubungi layanan pelanggan",
		input_password: 'Silakan masukkan sandi aset',
		betting: "Taruhan",

	},
	userInfo: {
		Head_portrait: "Avatar pribadi",
		account: "nomor rekening",
		Choose_picture: "Pilih Avatar",
		cancel: "batalkan",
		determine: "menentukan"
	},
	user: {
		wallet_account: "Akaun dompet",
		balance: "Perincian keseimbangan",
		top_up: "Recharge",
		withdrawal: "Pengunduran",
		my_wallet: "Dompetku.",
		add_wallet: "Tambah Dompet",
		look: "Lihat catatan",
		look_all: "See more",
		Pack_up: "Menyingkirkan",
		For_record: "Catatan pertukaran",
		bettingRecord: "Rincian transaksi",
		reward: "Hadiah promosi",
		goCustomerLink: "Layanan Online",
		Commission_account: "Akaun komisi",
		transfer: "transfer",
		number: "Data taruhan",
		transactiondetails: "View details",
		day: "Taruhan hari ini",
		day_winning: "menang hari ini",
		my_team: "Timku",
		about_we: "About us",
		center: "Pusat layanan pelanggan",
		setting: "mengatur",
	},
	transfer: {
		money: "Kesimbangan komisi",
		account_balance: "Account balance",
		number: "Kuantitas untuk dipindahkan",
		select: "Silakan pilih",
		Immediately_transfer: "Transfer segera",
		password: "Silakan masukkan sandi aset",
		betting: "Taruhan",

	},
	transactiondetails: {
		type: "tipe",
		input_type: "Silakan pilih tipe",
		date: "tanggal",
		select_date: "Silakan pilih tanggal",
		select: "pertanyaan",
		bettingmoney: "Jumlah taruhan",
		winning_amount: "Jumlah kemenangan",
		time: "waktu",
		not: "tidak ada data",
		B1: 'Comment-आकार',
		B2: 'Comment-संयोजन',
		B3: 'Comment-शुक्ष ड्रैगन और टिगर',
		B4: 'Comment-Name',
		B5: 'Comment-Lucky number',
		A1: 'हाशी इंटरटेमेंट सिटीCity name-Comment',
		A2: 'हाशी इंटरटेमेंट सिटीCity name-आश्चर्य बोट',
		A3: 'हाशी इंटरटेमेंट सिटीCity name-लास्की रेसहोर्स',
		A4: 'हाशी इंटरटेमेंट सिटीCity name-आकार',
		A5: 'हाशी इंटरटेमेंट सिटीCity name-संयोजन',
		A6: 'हाशी इंटरटेमेंट सिटीCity name-शुक्ष ड्रैगन और टिगर',
		A7: 'हाशी इंटरटेमेंट सिटीCity name-Name',
		A8: 'हाशी इंटरटेमेंट सिटीCity name-Lucky number',
		options: [{
			value: "Hash beruntung-two-sided",
			label: "B1",
		},
		{
			value: "Hash beruntung-kombinasi",
			label: "B2",
		},
		{
			value: "Hash beruntung-Dragon Tiger combination",
			label: "B3",
		},
		{
			value: "Hash beruntung-Baccarat",
			label: "B4",
		},
		{
			value: "Hash beruntung-Gel tunggal",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "Ubah kata sandi daftar masuk",
		assets_pwd: "Kata sandi aset",
		not: "Tidak ditetapkan",
		yes: "Set",
		language: "Pengaturan bahasa",
		exit: "sign out",

	},
	recharge: {
		recharge_code: "Memuat ulang rekaman",
		Chain_type: "Jenis rantai",
		address: "Ulangi alamat",
		copy_address: "Salin alamat",
		remind: "Peringatan operasi",
		content: "Kandungan isi isi isi isi isi isi isi isi isi"
	},
	myteam: {
		select: "pertanyaan",
		time: "tanggal",
		money: "Commission of the day",
		people: "Jumlah subordinat langsung",
		team: "tim",
		jryj: 'Hasil hari ini',
		jrsy: 'Penghasilan hari ini',
		ljsy: 'pendapatan kumulatif',
		friendsCategoryList: ['teman kelas satu', 'teman kedua', 'teman tingkat ketiga', 'teman kelas 4', 'teman tingkat 5'],
	},
	announcement: {
		title: 'Pengumuman Terbaru',
		close: 'penutupan',
	},
	login: {
		order_password: "Kata sandi lama",
		input_ordpwd: "Silakan masukkan kata sandi lama Anda",
		new_pwd: "New password",
		number: "Silakan tetapkan 6-16 huruf atas dan huruf kecil + angka",
		six_pwd: "Silakan masukkan kata sandi 6 digit",
		confirmPassword: "Konfirmasi kata sandi",
		confirm: "konfirmasi",
	},
	forrecord: {
		spending: "Biaya pertukaran",
	},
	exchangeRecord: {
		exchangeRecord: "pertukaran",
		record: "rekaman",
		For_spending: "Biaya pertukaran",
		money: "Jumlah pertukaran",
		exchange_number: "Bertukar jumlah",
		number: "nomor",
		market_price: "Market price",
		Miners_fee: "Gaji tambang",
		input_money: "Silakan masukkan jumlah pertukaran",
		Get_the_amount: "Jumlah yang diterima",
		Can_be: "Jumlah yang tersedia",
		address: "Alamat dompet",
		Immediatelychange: "Membalas sekarang",
		Warm_prompt: "peringatan",
		details: "Rincian Rincian Rincian Rincian"
	},
	balance: {
		balance_of: "balance",
		data: "tanggal",
		dataPickerRange: "Silakan pilih",
		select: "pertanyaan",
		to: 'to'
	},
	asset: {
		password: "Silakan tetapkan kata sandi 6 digit, yang tidak dapat mengandung ‘huruf, cocok dan ruang’",
		confirm: "konfirmasi",
	},
	add_address: {
		money_address: "Please enter wallet address（TRC20）",
		save: "konservasi"
	},
	spread: {
		cumulative: "Undangan kumulatif Anda",
		people: "orang",
		make: "Diperoleh",
		Continue_to: "Teruskan berjuang untuk hadiah besar",
		url: "Berbagi hubungan",
		Friends_registered: "Registrasi teman",
		money: "Dompet Pautan",
		Friends_deal: "Transaksi teman",
		copy_url: "Salin undangan link",
		my_group: "Timku",
		look: "Tampilkan rincian prestasi",
		directCount: "Jumlah subordinat langsung",
		group: "Jumlah tim",
		Commission_withdrawal: "Pengunduran komisi",
		historyAward: "Komisi Sejarah menerima",
		yesterdayAward: "Komisi kemarin",
		currentAward: "Komisi saat ini diterima",
		todayAward: "Pertunjukan hari ini",
		my_invite: "Kode undanganku",
		copy_invite: "Salin kode undangan",
		top_title: "Atasanku",
		update: "Tidak dapat diubah setelah orang tua terikat",
		nikname: "Silakan masukkan gelaran orang tua untuk mengikat",
		binding: "mengikat",

		Commission_ratio: "kadar komisi",
		level: "level",
		ratio: "nisbah rebate (jumlah taruhan)",
		Directly_under: "Subordinat langsung",
		first: "Yang pertama",
		levelone: "level",

	},
	performance: {
		datatime: "tanggal",
		pick: "Silakan pilih",
		select: "pertanyaan",
		total: "Total pertunjukan hari ini",
		performance: "Rincian prestasi",
		directCount: "Jumlah pemain langsung",
		todayTotalPerformByDirect: "Performasi pemain langsung hari ini",
		other: "Jumlah pemain lain",
		todayTotalPerformByOther: "Performance of other players",
		Commission_withdrawal: "Pengunduran komisi",
		historyAward: "Komisi Sejarah menerima",
		yesterdayAward: "Komisi kemarin",
		currentAward: "Komisi saat ini diterima",
		todayAward: "Pertunjukan hari ini",
		Commission_ratio: "kadar komisi",
		level: "level",
		ratio: "nisbah rebate (jumlah taruhan)",
		Directly_under: "Subordinat langsung",
		first: "Yang pertama",
		levelone: "level",
	},
	lotteryRecord: { //开奖记录
		block: "block",
		highly: "tinggi blok",
		results_of: "hasil",

	},
	help: {
		DAPP: "Langkah permainan DAPP",
		a: "Salin alamat permainan DAPP untuk transfer usdt-trc20",
		b: "Buka situs ini dalam perambar blockchain dompet (jaringan TRX), Anda dapat bertaruh pada DAPP segera tanpa menyalin",
		Focus_on: "Silakan selalu perhatikan untuk memperbaiki halaman rumah kita untuk mendapatkan alamat transaksi terbaru.",
		login: "Daftar masuk ke website resmi medan gelombang untuk bertanya nilai hash blok",
		hash: "Anda dapat menanyai nilai hash blok Anda di situs resmi medan gelombang",
		you: "Anda dapat mengunjungi website resmi medan gelombang",
		login_website: "Log masuk ke website resmi medan gelombang",
		query: "Tanyakan nilai hash blok Anda pada",
		look: "Klik untuk melihat tutorial",
		congratulations: "Selamat",
		winning: "Jika Anda memenangkan hadiah, sistem akan mengembalikan hadiah kepada Anda dalam 1 menit",
		address: "Jika Anda memenangkan hadiah, sistem akan mengembalikan hadiah ke alamat transfer Anda dalam 1 menit",
		number: "Beli usdt dan TRX dalam pertukaran mata uang digital",
		skip: "Jika dompet Anda sudah memiliki usdt dan TRX, Anda dapat melewatkan langkah ini",
		Digital_currency: "Beli usdt dan TRX dalam pertukaran mata uang digital, lalu pindahkan usdt dan TRX ke [dompet yang ditentralisasi]. Anda dapat menggunakan dompet yang terdaftar di situs dompet yang ditentralisasi berikut:",
		platform: "platform",
		url: "website",
		tutorial: "course",
		vpn: "Tip ramah: jika Anda tidak dapat membuka telegraf, Anda dapat menggunakan VPN Allah",
		vpnurl: "Magic lamp VPN website",
		whirlwind: "Website akselerator siklon",
		can_login: "Anda dapat log masuk",
		why: "Mengapaxxxx",
		most_fair: "Yang paling adil",
		play: "Tidak ada tendangan, tidak jatuh, tidak ada gangguan",
		Publicly_available: "Nilai hash blok secara acak dihasilkan, hasilnya disatukan, tidak dapat diubah, dan dapat diperiksa secara publik",
		security: "Safest",
		no_money: "Working capital can be seen. Don't worry about losing money",
		Cannot: "Catatan transfer pemilik dapat dilihat dan tidak dapat diterbitkan dengan palsu",
		Visi_convenient: "Yang paling nyaman",
		Without_registration: "Tidak perlu mendaftar, tidak perlu mengisi ulang, tidak perlu meminta penarikan",
		questions: "masalah umum",
		one: "Apa itu【Nilai hash blok】（Block Hash）",
		dna: "Nilai hash blok adalah DNA dari sepotong data. Setiap nilai hash blok unik, acak dan tidak dapat dihancurkan.",
		lookintroduce: "Klik untuk melihat perkenalan nilai hash enciklopedia Baidu。",
		what: "What blockchain",
		Block_chain: "In essence, blockchain is a shared database in which data or information is stored. Ini memiliki karakteristik bukan palsu, meninggalkan jejak di seluruh proses, pelacakan, terbuka dan transparan, pemeliharaan kolektif dan sebagainya.",
		wallet: "Dompet pusat? Dompet dekentralisasi? Why can't the centralized wallet query the transfer?",
		example: "Contohnya, jika alamat dompet Anda adalah a dan Anda memindahkan alamat e ke 10usdt, tetapi Anda menggunakan nilai hash transaksi untuk menanyakan, Anda hanya dapat menanyakan transfer antara alamat buku rekening acak penyedia layanan B (atau C atau D, dll.) dan E. Similarly, e cannot know whether these 10 usdts are transferred out by you, because e can only see that it is the account book address B that transfers in 10 usdts to him. This is why the centralized wallet cannot query the real transfer information on the block shoes.",
		why_winning: "Mengapa aku menang atau tidak menang berturut-turut",
		First: "Pertama-tama, ini adalah kejadian kemungkinan kecil yang belum memenangkan hadiah selama banyak kali berturut-turut",
		small: "Definisi peristiwa kemungkinan kecil",
		second: "Kedua, menang dan tidak menang adalah peristiwa acak, dan frekuensi peristiwa acak akan cenderung ke nilai stabil. Dalam kasus non-iteration, kemungkinan hal-hal muncul sama bagi semua orang. dalam kasus ini, semua orang adil. Pada saat yang sama, peristiwa acak akan mematuhi hukum dari jumlah besar (dalam kondisi bahwa tes tetap tidak berubah, ulangi tes banyak kali, dan frekuensi peristiwa acak sama dengan definisi hukum dari jumlah besar). Ketika frekuensi transfer terus meningkat, kemungkinan menang atau tidak menang akan cenderung ke nilai stabil. So please continue to transfer. As the transfer frequency increases, the total probability of winning the prize will increase.",
		whydelay: "Mengapa tertunda",
		Click_to_view: "Click to view the speed environment of blockchain: 《Trust is what counts, slow is what counts》",
		six: "Why is there a key when transferring money? Then what is the type option of usdt? Which one should I choose?",
		global: " There are many well-known public chains around the world",
		click_look: "Click to view the introduction of global Zhige public chain",
		how: "When transferring currency, what should I do if I transfer the address or select the wrong currency type? Can I return?",
		For_instance: "For example, when you transfer money to us, you should choose trc20 under USD, but if you choose Omni or usderc20 under other types of USD, you will lose money, which cannot be retrieved.",
		How_to_force: "Click to see what to do if you transfer the wrong currency?",
		Other_problems: "Other issues",
		callwe: "If you have any questions, please contact us",
		immediately: "Bertaruhan sekarang",
		company: "Company information",
		link: "Pautan",
		register: "Dental Digital Didaftar Deċentralisasi",
		Already_have: "If you already have a wallet, you can skip this step",
		download: "Turunkan dan daftar uang digital yang disentralisasi Dompet",
		com_title: "Tutorial website berkaitan dengan dompet uang digital adalah seperti ini"
	},
	register: { //登录注册
		login_tips: "Silakan reset sandi daftar masuk Anda",
		address: "Please enter wallet address",
		confirm: "Konfirmasi kata sandi",
		confirmupdate: "Confirm modification",
		toRegister: "Pergi mendaftar",
		agreement: "Sign in and agree",
		user: "Kesepakatan pengguna",
		policy: "Privacy policy",
		welcome: "Welcome to",
		login: "Log in to your account",
		forget: "Lupakan kata sandi",
		nowLogin: "Sign in",
		nologin: "Jangan log masuk sementara",
		new: "Buat akun baru",
		login: "Sebagai akun daftar masuk Anda",
		account: "Akun nomor 8-20 digit, nomor murni atau huruf",
		password: "Kata sandi lebih besar dari atau sama dengan 6 digit + huruf atau kombinasi karakter",
		confirm_password: "Konfirmasi kata sandi",
		inviteCode: "Silakan masukkan kode undangan (pilihan)",
		verificationCode: "Silakan masukkan kode verifikasi",
		toRegister: "register",
		noaccount: "Tidak ada rekening",
		toLogin: "Daftar masuk"
	},
	address: {
		warmprompt: "Tip hangat: Silakan isi alamat dompet yang benar, jika tidak Anda tidak dapat menarik uang. Setelah alamat dompet penarikan dipenuhi dan terikat, tidak dapat diubah. Jika Anda perlu mengubahnya, silakan hubungi layanan pelanggan",
		tips: "Silakan ikat setidaknya satu alamat dompet. Anda tidak dapat memperoleh saat Anda lupa kata sandi Anda",
		TRC20: "Untuk menghindari kesalahan masukan, silakan salin dan tekan panjang di sini untuk melekat (trc20)",
		toBind: "Ikat sekarang",
		noBind: "Do not bind temporarily",
	},
	luckyhash: { //幸运哈希
		walletName: 'Dompet Pautan',
		exchange: "pertukaran",
		reward: "hadiah",
		Customerservice: "customer service",
		instructions: "jelaskan",
		luckyhash: "Hash beruntung",
		entertainment: "Hashi Entertainment City",
		Doublesided: "two-sided",
		odds: "Kemungkinan",
		immediately: "Bertaruhan sekarang",
		combination: "kombinasi",
		LongHuge: "Dragon Tiger combination",
		baccarat: "Baccarat",
		gallbladder: "Gel tunggal",
		Hashracingcar: "Hash racing",
		Hashspeedboat: "Kapal kecepatan Hashi",
		Hashracing: "Berbalapan kuda",
		bothsides: "dua sisi",
		problem: "masalah umum",
		all: "See more",
		friend: "rekan kooperatif"
	},
	history: {
		block: "block",
		type: "tipe",
		big: "besar",
		highly: "tinggi blok",
		results_of: "hasil"
	},
	entertainment: {
		lastBlock: "Blok sebelumnya",
		resultValue: "Hasil loteri",
		currentblock: "Blok Semasa",
		nextBlock: "Blok loteri",
		toLotteryRecord: "Catatan loteri",
		block: "block",
		money1: "jumlah uang",
		type: "tipe",
		all: "See more",
		both_sides: "dua sisi",
		big: "besar",
		small: "Kecil",
		single: "tunggal",
		double: "ganda",
		champion: "juara",
		yajun: 'runner-up',
		he: '和',
		champion_one_size: "Juara ukuran tunggal",
		crown: "Guanyahe",
		andbig: "Heda",
		andsmall: "Dan kecil",
		andsingle: "Hedan",
		anddouble: "Dan ganda",
		championtwo: "Juara dua sisi",
		combination: "kombinasi",
		forlarge: "Perintah besar",
		smallsingle: "Order kecil",
		large_double: "Dashuang",
		small_double: "Xiao Shuang",
		Long_Huge: "Dragon Tiger combination",
		dragon: "Loong",
		tiger: "harimau",
		us: "tutup",
		baccarat: "Baccarat",
		zhuang: "ZhuangName",
		idle: "Leisure",
		gallbladder: "Gel tunggal",
		Atotalof: "umum",
		note: "notes",
		Check_the_details: "View details",
		money: "Balansi dompet",
		pause: "Pemilihan mesin",
		reset: "Reset",
		inputmoney: "Silakan masukkan jumlah",
		submit: "Kirim",
		password: "Silakan masukkan sandi transaksi",
		betting: "Taruhan",
		determine: "menentukan",
	},
	details: {
		block: "block",
		money: "jumlah uang",
		type: "tipe",
		resultValue: "Hasil loteri",
		all: "See more",
		address: "Alamat taruhan",
		toLotteryRecord: "Catatan loteri",
		money: "Taruhan dompet",
		copy: "Salin alamat taruhan",
		ts: "Tolong jangan gunakan alamat pertukaran, jika tidak Anda tidak akan menerima hadiah",
		USDT: "Silakan pindahkan medan gelombang usdt / TRX（Trc20）",
		Betting_amount: "Jumlah taruhan",
		inputmoney: "Silakan masukkan jumlah taruhan",
		confirm: "konfirmasi",
		cancel: "batalkan",
	},
	data: {
		noData: 'Tidak ada data',
		deleteSuc: 'Dihapus dengan sukses',
		iscon: 'Konfirmasi taruhan?',
		fenpan: 'Tidak diizinkan taruhan selama periode penutup',
		erweima: 'Simpan kode QR'
	},
	phone: {
		title: 'Ikat nomor ponsel',
		phone: 'nomor ponsel',
		input: 'Silakan masukkan nomor ponsel terikat',
		code: 'Kode Verifikasi',
		inputcode: "Silakan masukkan kode verifikasi",
		getCode: 'Dapatkan kode verifikasi',
		details: 'Silakan isi kode area dan nomor ponsel pertama',
		success: 'Kode pengesahan dikirim dengan sukses',
		bsuccess: 'Pengikatan berhasil',
		jiaoyi: 'Please set the transaction password first',
		caozuo: "Operasi berhasil",
		touxiang: "Silakan pilih gambar",
		buzu: 'Maaf, kreditmu kehabisan',
		tuiguan: 'Pusat Promosi',
		qubie: 'Klik untuk melihat perbedaan antara dompet blockchain',
		yhm: 'Silakan masukkan nama pengguna Anda',
		mm: 'Silakan masukkan sandi anda',
		xqgg: 'Pergi dan lihat dulu',
		llwm: 'hubungi kami',
		lj: 'Silakan sambungkan dompetmu dulu',
		dk: 'Tolong buka dalam aplikasi dompet',
		qd: 'Kami menantikan Anda bergabung',
		yjmx: 'Perincian komisi'
	},
	vip: {
		jl: "hadiah",
		xrjl: 'Newcomer reward',
		ckgz: 'Tampilkan aturan',
		zcsj: 'Deposit pendaftaran',
		qbsj: 'Ikat ponsel dan alamat dompet',
		dlq: 'unclaimed',
		qwc: 'Untuk',
		ylq: 'Diterima',
		tgrw: 'Tugas promosi',
		rwjl: 'Hadiah tugas',
		yq: 'undangan',
		ghy: 'Teman kualitas',
		lqcg: 'Diterima dengan sukses',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Indonesian.js